import React, { useCallback } from 'react';
import { useMediaQuery } from 'react-responsive';

import { DeviceContext } from '../../contexts';
import { Device } from '../../types';

export type DeviceProviderProps = {
  /**
   * React children nodes
   */
  children: React.ReactNode;
  /**
   * Tablet minimum media query width
   */
  tabletMinWidth: string;
  /**
   * Desktop minimum mediq query width
   */
  desktopMinWidth: string;
};

const DeviceProvider = ({
  children,
  tabletMinWidth,
  desktopMinWidth,
}: DeviceProviderProps) => {
  const getDeviceType = useCallback(
    ({ isTablet, isDesktop }: { isTablet: boolean; isDesktop: boolean }) => {
      let device: Device = 'mobile';
      if (isTablet) device = 'tablet';
      if (isDesktop) device = 'desktop';

      return device;
    },
    []
  );

  const isTablet = useMediaQuery({
    query: `(min-width: ${tabletMinWidth}) and (max-width: ${desktopMinWidth})`,
  });
  const isDesktop =
    useMediaQuery({ query: `(min-width: ${desktopMinWidth})` }) && !isTablet;

  return (
    <DeviceContext.Provider
      value={{ device: getDeviceType({ isTablet, isDesktop }) }}
    >
      {children}
    </DeviceContext.Provider>
  );
};

export default DeviceProvider;
